/**
 * Created by gzk on 2017-10-24.
 */
import {Injectable} from '@angular/core';
import {Platform, AlertController} from 'ionic-angular';
import {AppVersion} from '@ionic-native/app-version';
import {File} from '@ionic-native/file';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {FileTransfer,FileTransferObject} from "@ionic-native/file-transfer";

import { UserService } from "../data-service/user-service";
import {FileOpener} from "@ionic-native/file-opener";

@Injectable()
export class NativeService {

    APP_DOWNLOAD = 'https://itunes.apple.com/us/app/overdose/id1137430555?l=zh&ls=1&mt=8';//app下载地址
    APK_DOWNLOAD = 'http://foo.tp13.com/app/overdose.apk';//apk下载完整地址

    constructor(private platform: Platform,
                private alertCtrl: AlertController,
                private transfer: FileTransfer,
                private appVersion: AppVersion,
                private file: File,
                private inAppBrowser: InAppBrowser,
                private user:UserService,
                private fileOpener: FileOpener) {
    }

    /**
     * 检查app是否需要升级
     */
    detectionUpgrade() {

        //这里连接后台获取app最新版本号,然后与当前app版本号(this.getVersionNumber())对比
        this.user.getSystem({}).subscribe((resp:any)=>{

            if(resp.code >0)
            {
                let version = resp.data.app_version;
                this.getVersionNumber().then((value) =>{
                    if(parseInt(version.replace(',','')) > parseInt(value.replace(',','')))
                    {
                        this.APP_DOWNLOAD = resp.data.app_url;
                        this.APK_DOWNLOAD = resp.data.apk_url;
                        //版本号不一样就需要申请,不需要升级就return
                        this.alertCtrl.create({
                            title: '更新',
                            subTitle: '发现新版本'+version+',是否立即升级？如无法下载请手动下载.',
                            buttons: [{text: '取消'},
                                {
                                    text: '确定',
                                    handler: () => {
                                        this.downloadApp();
                                    }
                                }
                            ]
                        }).present();
                    }
                });
                //this.ref.markForCheck();
            }
        },(err)=>{

        });
    }

    /**
     * 下载安装app
     */
    downloadApp() {
        if (this.isAndroid()) {
            let alert = this.alertCtrl.create({
                title: '下载进度：0%',
                enableBackdropDismiss: false,
                buttons: ['后台下载']
            });
            alert.present();

            const fileTransfer: FileTransferObject = this.transfer.create();
            const apk = this.file.externalDataDirectory + 'overdose.apk'; //apk保存的目录

            fileTransfer.download(this.APK_DOWNLOAD, apk).then(() => {
                //window['install'].install(apk.replace('file://', ''));
                this.fileOpener.open(apk.replace('file://', ''), "application/vnd.android.package-archive");
            });

            fileTransfer.onProgress((event: ProgressEvent) => {
                let num = Math.floor(event.loaded / event.total * 100);
                if (num === 100) {
                    alert.dismiss();
                } else {
                    let title = document.getElementsByClassName('alert-title')[0];
                    title && (title.innerHTML = '下载进度：' + num + '%');
                }
            });
        }
        if (this.isIos()) {
            this.openUrlByBrowser(this.APP_DOWNLOAD);
        }
    }

    /**
     * 通过浏览器打开url
     */
    openUrlByBrowser(url:string):void {
        this.inAppBrowser.create(url, '_system');
    }

    /**
     * 是否真机环境
     * @return {boolean}
     */
    isMobile(): boolean {
        return this.platform.is('mobile') && !this.platform.is('mobileweb');
    }

    /**
     * 是否android真机环境
     * @return {boolean}
     */
    isAndroid(): boolean {
        return this.isMobile() && this.platform.is('android');
    }

    /**
     * 是否ios真机环境
     * @return {boolean}
     */
    isIos(): boolean {
        return this.isMobile() && (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone'));
    }

    /**
     * 获得app版本号,如0.01
     * @description  对应/config.xml中version的值
     * @returns {Promise<string>}
     */
    getVersionNumber(): Promise<string> {
        return new Promise((resolve) => {
            this.appVersion.getVersionNumber().then((value: string) =>
            {
                console.log('getVersionNumber:' + value);
                resolve(value);
            }).catch(err => {
                console.log('getVersionNumber:' + err);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/api-service/native-service.ts